import React, {Component} from "react";
import {ChatContainer} from "../containers/Chat";

class RootTemplate extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="c-grid">
                <div className="p-box__content">
                    <ChatContainer/>
                </div>
            </div>
        )
    }
}

export default RootTemplate